<template>
  <template v-if="isRawPage"><RouterView :key="routeViewKey" /></template>
  <template v-else>
    <Header />
    <section class="page-body">
      <LeftSide />
      <section class="page-content">
        <Breadcrumb />
        <main><RouterView :key="routeViewKey" /></main>
      </section>
    </section>
  </template>
</template>

<script setup>
  import Header from '@/components/header'
  import LeftSide from '@/components/leftSide'
  import Breadcrumb from '@/components/breadcrumb'
  import { computed } from 'vue'
  import { useRoute } from 'vue-router'

  const route = useRoute()
  const isRawPage = computed(() => route.path === '/login' || route.name === 'login')
  /** 路由变化时强制重建页面组件，确保 onMounted / 列表请求会重新执行 */
  const routeViewKey = computed(() => route.fullPath)
</script>

<style lang="less">
  *{
    margin: 0;
    padding: 0;
  }
  html, body{
    font-family: Avenir, Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    font-size: 14px;
    color: #333333;
  }
  #app {
    height: 100vh;
  }
  .page-body{
    display: flex;
    flex: 1;
  }
  .page-content{
    flex: 1;
    padding: 16px;
    height: calc(~"100vh - 40px");
    overflow: auto;
    box-sizing: border-box;
    display: flex;
    flex-direction: column;

    main{
      flex: 1;
      overflow: auto;
      display: flex;
      flex-direction: column;
    }
  }
</style>
